import { useEffect, useState, useCallback } from 'react'
import { Link, useLocation } from "react-router-dom";
import React from 'react'
import Menu from './Menu';

export default function Header({headerClass, headerHide}) {
  const [isSticky, setIsSticky] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

   const location = useLocation();

  // location value
  const locationData = {
    "resort-de-coracao-goa": {
      buttonlink:"https://www.swiftbook.io/inst/#home?propertyId=481MGhrFqip48IWZ2BdfBYNySqX3jg5Ng==&JDRN=Y"},

    "resort-de-coracao-rishikesh": {
      buttonlink:"https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU="},

    "resort-de-coracao-corbett": {
      buttonlink:"https://www.swiftbook.io/inst/#home?propertyId=962MjsYOXZHJZLgLW4fVmXUGy1o5kn1R4GHQlUf4SKx6SGkIeEltbc5NQ==&JDRN=Y"},
  };

  // Default value
  const defaultData = {
    buttonlink:"https://www.swiftbook.io/inst/#group?groupId=381M25HpcJdio6EBB8BhhWNjE2NzE=&JDRN=Y"};


  // slug detect
  const currentSlug = Object.keys(locationData).find((slug) =>
    location.pathname.includes(slug)
  );

  const currentData = locationData[currentSlug] || defaultData;

  const isRishikesh = currentSlug === "resort-de-coracao-rishikesh";

  const handleToggleMenu = useCallback(
    () => setIsOpen((prev) => !prev),
    []
  );

  const handleScroll = useCallback(() => {
    const heightFromTop = window.scrollY;
    setIsSticky(heightFromTop > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);


  return (  
    <>
      <header className={`header-area ${isSticky ? 'stick' : ''} ${headerClass}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-sm-4 col-4">
              <div className="logo">
                <Link to={"/"}>
                    {/* Rishikesh slug  */}
                    {isRishikesh ? (
                      (headerClass && !isSticky) ? (
                        <img src="/image/rishikesh-logo-white.webp" alt="Logo" />
                      ) : (
                        <img src="/image/rishikesh-logo-black.webp" alt="Logo" />
                      )
                    ) : (
                      /* Default logos */
                      (headerClass && !isSticky) ? (
                        <img src="/image/logo-white.webp" alt="Logo" />
                      ) : (
                        <img src="/image/logo.webp" alt="Logo" />
                      )
                    )}
                </Link>
              </div>
            </div>

            <div className="col-lg-6 col-sm-8 col-8">
              <div className="main-headerlink">
                    <a href="tel:+91 9292928787" className='phone-link'><img src="/image/phone-icon.webp" alt="phone" /> +91 929292 8787</a>
                    
                  <Link to={currentData.buttonlink} target="_blank" className='headermore headerbook'><img src="/image/calender.webp" alt="calender" /> Book My Stay</Link>

                  <Link className='headermenu' onClick={handleToggleMenu}>
                      Menu
                      <div className="menu-toogle">
                            <div className="menu-line icon-top"></div>
                            <div className="menu-line icon-center"></div>
                            <div className="menu-line icon-bottom"></div>
                        </div>
                  </Link>
              </div>
            </div>
            
          </div>
        </div>
      </header>

      <Menu isOpen={isOpen} setIsOpen={setIsOpen}/>
    </>
  )
}
